<template>
  <a-modal
    title="Production Usage"
    centered
    :width="1200"
    :visible="visible"
    @cancel="handleCancel"
  >
    <a-input-search
      v-model="search"
      placeholder="input search text"
      class="margin-bottom"
    />
    <a-table bordered :columns="column" :dataSource="datasource" rowKey="id_transaksi"
      :scroll="{ x: 1500, y: 500 }">
      <template slot="deskripsi" slot-scope="record, item">
        <h4 class="margin-remove">
          <!-- <a @click="handleManifest(item)"> -->
            {{
            `${item.header} ( ${item.no_transaksi} )`
          }}
          <!-- </a> -->
        </h4>
        <span>{{ item.keterangan }}</span>
      </template>
      <template slot="createDt" slot-scope="record, item">
        <span>{{ item.tgl_transaksi }}</span>
      </template>
      <template slot="status" slot-scope="record, item">
        <status :status="item.status" />
      </template>
      <template slot="value" slot-scope="record, item">
        <span>{{ formatCurrency(item.mata_uang, item.value) }}</span>
      </template>
      <template slot="realisasi" slot-scope="record, item">
        <span>{{ formatCurrency(item.mata_uang, item.realisasi) }}</span>
      </template>
      <template slot="balance" slot-scope="record, item">
        <span>{{ formatCurrency(item.mata_uang, item.balance_allocated) }}</span>
      </template>
      <template slot="transfer" slot-scope="record, item">
        <span>{{ formatCurrency(item.mata_uang, item.transfered) }}</span>
      </template>
      <template slot="notyet" slot-scope="record, item">
        <span>{{ formatCurrency(item.mata_uang, item.not_yet_transfered) }}</span>
      </template>
      <template slot="footer" slot-scope="currentPageData">
        <a-row :gutter="8">
          <a-col :xs="{ span: getScreen ? 12 : 18}" :lg="{ span: getScreen ? 12 : 18}">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <!-- <span>Total Budget</span> -->
                <span>&nbsp;</span>
                <h2>
                  <!-- {{ formatCurrency(source.mata_uang, source.total_budget) }} -->
                  &nbsp;
                </h2>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 12 : 6 }" :lg="{ span: getScreen ? 12 : 6 }">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <span style="font-size: medium;">Total Budget <b>(a)</b></span>
                <h2>
                  {{ formatCurrency(source.mata_uang, source.total_budget) }}
                </h2>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-divider style="margin:0px!important"></a-divider>
        <a-row :gutter="8">
          <a-col :xs="{ span: getScreen ? 12 : 6}" :lg="{ span: getScreen ? 12 : 6}">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div style="border-right: solid 3px grey;padding-right: 5px">
                <span style="font-size: medium;">Balance Allocated Percentage</span>
                <h2>
                  {{ isNaN(source.total_sisa/source.total_alokasi) ? 0 : Math.round(source.total_sisa/source.total_alokasi*100,2) }} %
                </h2>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 12 : 6}" :lg="{ span: getScreen ? 12 : 6}">
            <div>&nbsp;</div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 12 : 6}" :lg="{ span: getScreen ? 12 : 6}">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <span style="font-size: medium;">Balance Allocated <b>(c = b-d)</b></span>
                <h2>
                  {{ formatCurrency(source.mata_uang, source.total_sisa) }}
                </h2>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 12 : 6 }" :lg="{ span: getScreen ? 12 : 6 }">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <span style="font-size: medium;">Allocated <b>(b)</b></span>
                <h2>
                  {{ formatCurrency(source.mata_uang, source.total_alokasi) }}
                </h2>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-divider style="margin:0px!important"></a-divider>
        <a-row :gutter="8">
          <a-col :xs="{ span: getScreen ? 8 : 6}" :lg="{ span: getScreen ? 8 : 6}">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div style="border-right: solid 3px grey;padding-right: 5px">
                <span style="font-size: medium;">Realized Percentage</span>
                <h2>
                  {{ isNaN(source.total_realisasi/source.total_alokasi) ? 0 : Math.round(source.total_realisasi/source.total_alokasi*100,2) }} %
                </h2>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 8 : 6}" :lg="{ span: getScreen ? 8 : 6}">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <span style="font-size: medium;">Not Yet Transferred <b>(f)</b></span>
                <h2>
                  {{ formatCurrency(source.mata_uang, source.not_yet_transfer) }}
                </h2>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 8 : 6 }" :lg="{ span: getScreen ? 8 : 6 }">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <span style="font-size: medium;">Transferred <b>(e)</b></span>
                <h2>
                  {{ formatCurrency(source.mata_uang, source.total_transfer) }}
                </h2>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 8 : 6 }" :lg="{ span: getScreen ? 8 : 6 }">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <span style="font-size: medium;">Realized <b>(d = e+f)</b></span>
                <h2>
                  {{ formatCurrency(source.mata_uang, source.total_realisasi) }}
                </h2>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-divider style="margin:0px!important"></a-divider>
        <a-row :gutter="8">
          <a-col :xs="{ span: getScreen ? 8 : 6 }" :lg="{ span: getScreen ? 8 : 6 }">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div style="border-right: solid 3px grey;padding-right: 5px">
                <span style="font-size: medium;">Balance Budget Percentage</span>
                <h2>
                  {{ isNaN(source.total_sisa_alokasi/source.total_budget) ? 0 : Math.round((source.total_sisa_alokasi/source.total_budget)*100,2) }} %
                </h2>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 8 : 12 }" :lg="{ span: getScreen ? 8 : 12 }">
            <div>&nbsp;</div>
          </a-col>
          <a-col :xs="{ span: getScreen ? 8 : 6 }" :lg="{ span: getScreen ? 8 : 6 }">
            <div class="footer-information" style="padding: 10px 15px 15px 15px!important;min-height:auto!important">
              <div>
                <span style="font-size: medium;">Balance Budget <b>(a-b)</b></span>
                <h2>
                  {{ formatCurrency(source.mata_uang, source.total_sisa_alokasi) }}
                </h2>
              </div>
            </div>
          </a-col>
        </a-row>
      </template>
    </a-table>
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        Tutup
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import { mapGetters } from "vuex";
export default {
  name: "ModalCodeBudget",
  props: {
    visible: Boolean,
    cancel: Function,
    kode: "",
    source: {},
  },
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    const column = [
      {
        title: "Description",
        scopedSlots: { customRender: "deskripsi" },
        key: "header",
        width: 200
      },
      {
        title: "Date Created",
        scopedSlots: { customRender: "createDt" },
        key: "createDt",
        align: "center",
      },
      {
        title: "Status",
        scopedSlots: { customRender: "status" },
        key: "status",
        align: "center",
      },
      {
        title: 'ALLOCATION',
        children: [
          {
            title: "Value / Alocated",
            scopedSlots: { customRender: "value" },
            key: "value",
            align: "right",
          },
          {
            title: "Balanced / Alocated",
            scopedSlots: { customRender: "balance" },
            key: "balance",
            align: "right",
          },
        ]
      },
      {
        title: 'REALIZATION',
        children: [
          {
            title: "Realized",
            scopedSlots: { customRender: "realisasi" },
            key: "realisasi",
            align: "right",
          },
          {
            title: "Transferred",
            scopedSlots: { customRender: "transfer" },
            key: "transfer",
            align: "right",
          },
          {
            title: "Not Yet Transferred",
            scopedSlots: { customRender: "notyet" },
            key: "notyet",
            align: "right",
          },
        ]
      }
    ];
    return {
      column,
      search: "",
    };
  },
  computed: {
    ...mapGetters(["getAuth","getScreen"]),
    datasource() {
      let data = this.source.detil_realisasi;
      data = _.filter(data, (obj) =>
              (obj.header == null ? "":obj.header.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 )||
              (obj.no_transaksi == ""? null:obj.no_transaksi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 )||
              (obj.status == null ? "":obj.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 )||
              (obj.value ==  null ? "":obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 )||
              (obj.realisasi == null ? "":obj.realisasi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
      );

      return data;
    },
  },
  methods: {
    handleManifest(item) {
      const data = {
        rest_api: item.rest_api,
        id_manifest: item.id_transaksi,
        tlc: this.getAuth.username,
        user_pembuat: item.pembuat,
      };

      this.handleView(data);
    },
    handleCancel() {
      this.search = "";
      this.cancel();
    },
  },
};
</script>

<style lang="less" scoped>
.footer-information {
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  padding: @padding;

  &:nth-child(n) {
    span {
      font-size: 0.8rem;
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }

    h2 {
      margin: 0;
    }
  }
}
</style>
